import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FEATURE_TOGGLE_NOTIFICATION } from "../config";
import { FormattedMessage } from "react-intl";

export const PaymentStatus = {
  DUE: "due",
  UNPAID: "unpaid",
  PAID: "paid",
  VERIFIED: "verified",
  FAILED: "failed"
};
export const deadlineModePayment = [
  {
    key: "PM01",
    desc: "deadlines.payment.PM01" 
  },
  {
    key: "PM02",
    desc: "deadlines.payment.PM02" 
  },
  {
    key: "PM03",
    desc: "deadlines.payment.PM03" 
  },
  {
    key: "PM04",
    desc: "deadlines.payment.PM04" 
  },
  {
    key: "PM05",
    desc: "deadlines.payment.PM05" 
  },
  {
    key: "PM06",
    desc: "deadlines.payment.PM06" 
  },
  {
    key: "PM07",
    desc: "deadlines.payment.PM07" 
  },
  {
    key: "PM08",
    desc: "deadlines.payment.PM08" 
  },
  {
    key: "PM09",
    desc: "deadlines.payment.PM09" 
  },
  {
    key: "PM12",
    desc: "deadlines.payment.PM12" 
  },
  {
    key: "PM13",
    desc: "deadlines.payment.PM13" 
  },
  {
    key: "PM14",
    desc: "deadlines.payment.PM14" 
  },
  {
    key: "PM15",
    desc: "deadlines.payment.PM15" 
  },
  {
    key: "PM16",
    desc: "deadlines.payment.PM16" 
  },
  {
    key: "PM19",
    desc: "deadlines.payment.PM19" 
  },
  {
    key: "PM22",
    desc: "deadlines.payment.PM22" 
  },
  {
    key: "PM23",
    desc: "deadlines.payment.PM23" 
  },
  {
    key: "PMXC",
    desc: "deadlines.payment.PMXC" 
  },
  {
    key: "PMXA",
    desc: "deadlines.payment.PMXA" 
  }
];

export const deadlineTypes = [
  {
    key: "irpef",
    desc: <FormattedMessage id="deadlines.pages.table.irpef" />
  },
  {
    key: "irap",
    desc: <FormattedMessage id="deadlines.pages.table.irap" />
  },
  {
    key: "ires",
    desc: <FormattedMessage id="deadlines.pages.table.ires" />
  },
  {
    key: "imu",
    desc: <FormattedMessage id="deadlines.pages.table.imu" />
  },
  {
    key: "tasi",
    desc: <FormattedMessage id="deadlines.pages.table.tasi" />
  },
  {
    key: "ivs",
    desc: <FormattedMessage id="deadlines.pages.table.ivs" />
  },
  {
    key: "f24",
    desc: <FormattedMessage id="deadlines.pages.table.f24" />
  },
  {
    key: "f23",
    desc: <FormattedMessage id="deadlines.pages.table.f23" />
  },
  {
    key: "iva_down_payment",
    desc: <FormattedMessage id="deadlines.pages.table.ivaDownPayment" />
  },
  {
    key: "iva_payment",
    desc: <FormattedMessage id="deadlines.pages.table.ivaPayment" />
  }
];

export const deadlinesScopes = {
  fiscal_social_security: <FormattedMessage id="deadlines.pages.table.fiscalSocialSecurity" />,
  credit: <FormattedMessage id="deadlines.pages.table.credit" />,
  debt: <FormattedMessage id="deadlines.pages.table.debt" />,
  studio_reminder: <FormattedMessage id="deadlines.pages.table.studioReminder" />
};

export const deadlinesScopesList = {
  fiscal_social_security: <FormattedMessage id="deadlines.pages.table.fiscalSocialSecurity" />,
  credit: <FormattedMessage id="deadlines.pages.table.credit" />,
  debt: <FormattedMessage id="deadlines.pages.table.debt" />,
  studio_reminder: <FormattedMessage id="deadlines.pages.table.studioReminder" />,
  rent: <FormattedMessage id="deadlines.pages.table.rent" />,
  financing: <FormattedMessage id="deadlines.pages.table.financing" />,
  recurring_fees: <FormattedMessage id="deadlines.pages.table.recurring_fees" />
};

export const deadlinesRecurringScopes = {
  fiscal_social_security: <FormattedMessage id="deadlines.pages.table.fiscalSocialSecurity" />,
  studio_reminder: <FormattedMessage id="deadlines.pages.table.studioReminder" />,
  rent: <FormattedMessage id="deadlines.pages.table.rent" />,
  financing: <FormattedMessage id="deadlines.pages.table.financing" />,
  recurring_fees: <FormattedMessage id="deadlines.pages.table.recurring_fees" />
};

export const deadlinePaymentTypes = [
  {
    key: "item_pays_collect",
    desc: (
      <React.Fragment>
        <FontAwesomeIcon icon={["fas", "user"]} className="deadlines_handle_select_item svg" />
        <FormattedMessage id="deadlines.pages.table.itemPays" />
      </React.Fragment>
    )
  },
  {
    key: "manager_pays",
    desc: (
      <React.Fragment>
        <FontAwesomeIcon icon={["fas", "briefcase"]} className="deadlines_handle_select_item svg" />
        <FormattedMessage id="deadlines.pages.table.managerPays" />
      </React.Fragment>
    )
  },
  {
    key: "manager_charge",
    desc: (
      <React.Fragment>
        <FontAwesomeIcon icon={["fas", "university"]} className="deadlines_handle_select_item svg" />
        <FormattedMessage id="deadlines.pages.table.managerCharge" />
      </React.Fragment>
    )
  }
];

export const deadlineSeenTypes = [  
  {
    key: "true",
    desc: <FontAwesomeIcon icon={["fas", "check-circle"]} className={"readYes"} />
  },
  {
    key: "false",
    desc: <FontAwesomeIcon icon={["fas", "check-circle"]} className={"readNo"} />
  }
];

export const deadlineStatuses = [ 
  {
    key: "authorized",
    desc: "deadlines.authorized"
  },
  {
    key: "rejected",
    desc: "deadlines.notAuthorized"
  },
  {
    key: "to_be_paid",
    desc: "deadlines.pages.table.due"
  },
  {
    key: "to_be_collected",
    desc: "deadlines.pages.table.toCash"
  },
  {
    key: "unpaid",
    desc: "deadlines.unpaid"
  },
  {
    key: "paid",
    desc: "deadlines.paid"
  },
  {
    key: "pending",
    desc: "deadlines.pages.table.pending"
  },
  /* {
    key: "failed",
    desc: "deadlines.failed"
  }, */
  {
    key: "collected",
    desc: "deadlines.collected"
  },
  {
    key: "suspended",
    desc: "deadlines.suspended"
  },
  {
    key: "rebated",
    desc: "deadlines.pages.table.rebated"
  }
];

export const paymentStatus = [
  {
    key: "authorized",
    desc: <FormattedMessage id="deadlines.authorized" />
  },
  {
    key: "pending",
    desc: <FormattedMessage id="deadlines.pages.table.pending" />
  },
  {
    key: "failed",
    desc: <FormattedMessage id="deadlines.failed" />
  },
  {
    key: "rejected",
    desc: <FormattedMessage id="deadlines.notAuthorized" />
  },
  {
    key: "to_be_paid",
    desc: <FormattedMessage id="deadlines.pages.table.due" />
  },
  {
    key: "to_be_collected",
    desc: <FormattedMessage id="deadlines.pages.table.toCash" />
  },
  {
    key: "unpaid",
    desc: <FormattedMessage id="deadlines.unpaid" />
  },
  {
    key: "paid",
    desc: <FormattedMessage id="deadlines.paid" />
  },
  {
    key: "collected",
    desc: <FormattedMessage id="deadlines.collected" />
  },
  {
    key: "suspended",
    desc: <FormattedMessage id="deadlines.suspended" />
  },
  {
    key: "rebated",
    desc: <FormattedMessage id="deadlines.pages.table.rebated" />
  }
];

export const deadlineTaxRegime = [
  {
    key: null,
    desc: <FormattedMessage id="generic.all" />
  },
  {
    key: "RF01",
    desc: <FormattedMessage id="deadlines.pages.table.RF01" />
  },
  {
    key: "RF02",
    desc: <FormattedMessage id="deadlines.pages.table.RF02" />
  },
  {
    key: "RF03",
    desc: <FormattedMessage id="deadlines.pages.table.RF03" />
  },
  {
    key: "RF04",
    desc: <FormattedMessage id="deadlines.pages.table.RF04" />
  },
  {
    key: "RF05",
    desc: <FormattedMessage id="deadlines.pages.table.RF05" />
  },
  {
    key: "RF06",
    desc: <FormattedMessage id="deadlines.pages.table.RF06" />
  },
  {
    key: "RF07",
    desc: <FormattedMessage id="deadlines.pages.table.RF07" />
  },
  {
    key: "RF08",
    desc: <FormattedMessage id="deadlines.pages.table.RF08" />
  },
  {
    key: "RF09",
    desc: <FormattedMessage id="deadlines.pages.table.RF09" />
  },
  {
    key: "RF10",
    desc: <FormattedMessage id="deadlines.pages.table.RF10" />
  },
  {
    key: "RF11",
    desc: <FormattedMessage id="deadlines.pages.table.RF11" />
  },
  {
    key: "RF12",
    desc: <FormattedMessage id="deadlines.pages.table.RF12" />
  },
  {
    key: "RF13",
    desc: <FormattedMessage id="deadlines.pages.table.RF13" />
  },
  {
    key: "RF14",
    desc: <FormattedMessage id="deadlines.pages.table.RF14" />
  },
  {
    key: "RF15",
    desc: <FormattedMessage id="deadlines.pages.table.RF15" />
  },
  {
    key: "RF16",
    desc: <FormattedMessage id="deadlines.pages.table.RF16" />
  },
  {
    key: "RF17",
    desc: <FormattedMessage id="deadlines.pages.table.RF17" />
  },
  {
    key: "RF18",
    desc: <FormattedMessage id="deadlines.pages.table.RF18" />
  },
  {
    key: "RF19",
    desc: <FormattedMessage id="deadlines.pages.table.RF19" />
  }
];

export const arrayHeaderTable = (
  enableCheckbox, isHeader, companies, genericAllText
) => {
  let items = [];

  let companiesReact = [];
  if (companies) {
    companies.map((it) => {
      return companiesReact.push({
        key: it.key,
        desc: it.desc
      });
    });
  }

  if (enableCheckbox && isHeader) {
    items.push({
      id: "checkbox",
      label: "",
      boKey: "checkbox",
      mappingIntoState: "checkbox",
      className: "itsWidth_deadline customWidth_deadline7 row3perc"
    });
  }
  return items.concat([
    {
      id: "date",
      label: <FormattedMessage id="deadlines.deadlineDateColumn" />,
      boKey: "date",
      mappingIntoState: "fromDate.toDate",
      className: "itsWidth_deadline alignCenter row8perc"
    },
    {
      id: "item",
      label: <FormattedMessage id="deadlines.pages.table.company" />,
      placeholder: <FormattedMessage id="generic.all" />,
      formType: "selectbox",
      boKey: "itemDetails.itemId",
      dataSource: [{ key: null, desc: genericAllText }].concat(companiesReact),
      mappingIntoState: "itemId",
      className: "itsWidth_deadline customWidth_deadline2 row10perc",
      // nullValueMappedWith: " ",
      fitContent: true,
      showSearch: true
    },
    {
      id: "deadlineRowCounterpart",
      label: <FormattedMessage id="deadlines.pages.table.counterpart" />,
      hidden: false,
      className: `itsWidth_deadline ${enableCheckbox ? "row10perc" : "row12perc"}`,
      placeholder: <FormattedMessage id="generic.all" />,
      formType: null,
      boKey: "deadlines.counterpart.taxId",
      mappingIntoState: "counterpartTaxId",
      nullValueMappedWith: " ",
      fitContent: true,
      showSearch: true
    },

    {
      id: "deadlineRowTitle",
      label: <FormattedMessage id="deadlines.pages.table.title" />,
      formType: null,
      hidden: false,
      className: `itsWidth_deadline ${enableCheckbox ? "row11perc" : "row13perc"}`
    },
    {
      id: "amount",
      label: <FormattedMessage id="deadlines.balance" />,
      formType: null,
      hidden: false,
      className: "itsWidth_deadline alignCenter row11perc amountCol"
    },
    {
      id: "paymentMode",
      label: <FormattedMessage id="deadlines.pages.table.paymentTypeMinus" />,
      formType: "selectbox",
      placeholder: <FormattedMessage id="generic.all" />,
      dataSource: [{ key: null, desc: <FormattedMessage id="generic.all" /> }].concat(deadlineModePayment),
      boKey: "payment.mode.id",
      mappingIntoState: "paymentMode",
      className: "itsWidth_deadline row7perc",
      showSearch: true
    },
    {
      id: "paymentType",
      label: <FormattedMessage id="deadlines.pages.table.handle" />,
      widthAdded: 0,
      formType: "selectbox",
      placeholder: <FormattedMessage id="generic.all" />,
      dataSource: deadlinePaymentTypes,
      boKey: "payment.type",
      mappingIntoState: "paymentType",
      className: "itsWidth_deadline alignCenter row6perc",
      fitContent: true
    },
    {
      id: "status",
      label: <FormattedMessage id="deadlines.pages.table.status" />,
      placeholder: <FormattedMessage id="generic.all" />,
      widthAdded: 0,
      formType: "selectbox-multi",
      dataSource: deadlineStatuses,
      mappingIntoState: "status",
      className: "itsWidth_deadline row10perc",
      fitContent: true,
      showSearch: true
    },
    {
      id: "viewed",
      label: <FormattedMessage id="deadlines.pages.table.viewed" />,
      widthAdded: 0,
      maxWidth: 100,
      formType: "selectbox",
      dataSource: deadlineSeenTypes,
      placeholder: "-",
      boKey: "status.viewed",
      mappingIntoState: "viewed",
      className: "itsWidth_deadline alignCenter row5perc",
      showSearch: false
    },

    FEATURE_TOGGLE_NOTIFICATION === "true"
      ? {
        id: "notify",
        label: "",
        formType: null,
        hidden: false,
        className: "itsWidth_deadline row3perc"
      }
      : {},
    {
      id: "notesCount",
      label: "",
      formType: null,
      hidden: false,
      className: "itsWidth_deadline customWidth_deadline7 row3perc"
    },
    {
      id: "preview",
      label: "",
      formType: null,
      hidden: false,
      className: "itsWidth_deadline customWidth_deadline7 row3perc"
    },
    {
      id: "actions",
      label: "",
      formType: null,
      hidden: false,
      className: "itsWidth_deadline customWidth_deadline7 row3perc"
    }
  ]);
};

export const arrayCustomersHeaderTable = (enableCheckbox, isHeader) => {
  let items = [];

  if (enableCheckbox && isHeader) {
    items.push({
      id: "checkbox",
      label: "",
      boKey: "checkbox",
      mappingIntoState: "checkbox",
      className: "itsWidth_deadline row4perc"
    });
  }
  return items.concat([
    {
      id: "date",
      label: <FormattedMessage id="deadlines.deadlineDateColumn" />,
      boKey: "date",
      mappingIntoState: "fromDate.toDate",
      className: "itsWidth_deadline alignCenter row9perc"
    },

    {
      id: "deadlineRowTitle",
      label: <FormattedMessage id="deadlines.pages.table.title" />,
      formType: null,
      hidden: false,
      className: "itsWidth_deadline row16perc"
    },

    {
      id: "deadlineRowCounterpart",
      label: <FormattedMessage id="deadlines.pages.table.counterpart" />,
      hidden: false,
      className: "itsWidth_deadline row16perc",
      placeholder: <FormattedMessage id="generic.all" />,
      formType: null,
      boKey: "deadlines.counterpart.description",
      mappingIntoState: "counterpart",
      nullValueMappedWith: " ",
      fitContent: true,
      showSearch: true
    },
    {
      id: "amount",
      label: <FormattedMessage id="deadlines.balance" />,
      formType: null,
      hidden: false,
      className: "itsWidth_deadline alignCenter row10perc"
    },
    {
      id: "paymentMode",
      label: <FormattedMessage id="deadlines.pages.table.paymentTypeMinus" />,
      formType: "selectbox",
      placeholder: <FormattedMessage id="generic.all" />,
      dataSource: [{ key: null, desc: <FormattedMessage id="generic.all" /> }].concat(deadlineModePayment),
      boKey: "payment.mode.id",
      className: `itsWidth_deadline ${enableCheckbox ? "row13perc" : "row15perc"}`,
      mappingIntoState: "paymentMode",
      showSearch: true
    },
    {
      id: "paymentType",
      label: <FormattedMessage id="deadlines.pages.table.handle" />,
      widthAdded: 0,
      formType: "selectbox",
      placeholder: <FormattedMessage id="generic.all" />,
      dataSource: deadlinePaymentTypes,
      boKey: "payment.type",
      mappingIntoState: "paymentType",
      className: "itsWidth_deadline alignCenter row7perc",
      fitContent: true,
      showSearch: true
    },
    {
      id: "status",
      label: <FormattedMessage id="deadlines.pages.table.status" />,
      placeholder: <FormattedMessage id="generic.all" />,
      widthAdded: 0,
      formType: "selectbox-multi",
      dataSource: deadlineStatuses,
      mappingIntoState: "status",
      className: "itsWidth_deadline row15perc",
      fitContent: true,
      showSearch: true
    },
    {
      id: "notesCount",
      label: "",
      formType: null,
      hidden: false,
      className: "itsWidth_deadline customWidth_deadline7 row3perc"
    },
    {
      id: "preview",
      label: "",
      formType: null,
      hidden: false,
      className: "itsWidth_deadline"
    }
  ]);
};

/** Costruiamo una lista di oggetti per renderizzare i tabs */
export function getArrayTabs(activeTab) {
  return [
    {
      id: 0,
      nameTab: "Fiscali e previdenziali effettive",
      isActive: activeTab === 0
    },
    {
      id: 1,
      nameTab: "Fiscali e previdenziali pianificate",
      isActive: activeTab === 1
    },
    {
      id: 2,
      nameTab: "Altre scadenze",
      isActive: activeTab === 2
    }
  ];
}

export const deadlinesPayment = {
  /** si è deciso a passare da PMxx a PMxx per distinguere
   * dai pagamenti fattura di origine */
  PMXA: "deadlines.payment.PMXA",
  PM01: "deadlines.payment.PM01",
  PM02: "deadlines.payment.PM02",
  PM03: "deadlines.payment.PM03",
  PM04: "deadlines.payment.PM04",
  PM05: "deadlines.payment.PM05",
  PM06: "deadlines.payment.PM06",
  PM07: "deadlines.payment.PM07",
  PM08: "deadlines.payment.PM08",
  PM09: "deadlines.payment.PM09",
  PM12: "deadlines.payment.PM12",
  PM13: "deadlines.payment.PM13",
  PM14: "deadlines.payment.PM14",
  PM15: "deadlines.payment.PM15",
  PM16: "deadlines.payment.PM16",
  PM19: "deadlines.payment.PM19",
  PM22: "deadlines.payment.PM22",
  PM23: "deadlines.payment.PM23",
  PMXC: "deadlines.payment.PMXC"
};
